import { Component, h, Host, Listen } from "@stencil/core";

@Component({
    tag: "ux-radio-button-media-group",
    styleUrl: "radio-button-media-group.scss",
    shadow: false,
})
export class RadioButtonMediaGroup {
    @Listen("uxRadioButtonChange")
    onValueChange(e: CustomEvent) {
        this.setCssCLasses(e);
    }

    private setCssCLasses = (e: CustomEvent) => {
        var radioButtons = document.querySelectorAll(
            `.ux-radio-button-media-group input[type=radio][name=${e.detail.name}]`
        );

        if (radioButtons) {
            radioButtons.forEach(function (el) {
                var uxElement = el.closest(".ux-radio-button-field");

                if (uxElement) {
                    if (
                        e.detail.value == (el as HTMLUxRadioButtonElement).value
                    ) {
                        uxElement.classList.add(
                            "ux-radio-button-field--active"
                        );
                    } else {
                        uxElement.classList.remove(
                            "ux-radio-button-field--active"
                        );
                    }
                }
            });
        }
    };

    render() {
        const baseClass = "ux-radio-button-media-group";

        return (
            <Host
                class={{
                    [baseClass]: true,
                }}
            >
                <slot />
            </Host>
        );
    }
}
